<div class="details">
   
    <div class="title mb-5">
        <div class="contact" id="title-bloc"><h4 >Note moyenne  ({{reviewCompany?.nb_avis}})</h4></div>
        <div  style="margin: left;">
            <div class="stars mb-3">
                <rating [titles]="[' ',' ',' ',' ',' ']" [readonly]="true"
                class="rating custom-rating-star"  [(ngModel)]="averageNoteTotal"></rating>
            </div>
        </div>
    </div>
    <!-- <div class="avis" style="display: flex;">
        <div>
        <span>Avis moyenne : </span>
         </div>
        <div>
          
        </div>
    </div> -->
    <!-- <div class="avis">
        <span>Nombre des avis : {{reviewCompany?.nb_avis}} </span>
    </div> -->
    <div class="avis" style="display: flex;justify-content: space-between;" *ngFor="let questionReview of reviewCompany?.data">
        <div>
        <span>{{questionReview?.question}} </span>
    </div>
        <div >
            <div style="margin: auto;">
                <div class="stars mb-3">
                    <rating [titles]="[' ',' ',' ',' ',' ']" [readonly]="true"   [(ngModel)]="questionReview.average_note"
                        class="rating-stars"></rating>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row mt-15 details" *ngIf="disabledMode">
   


    <div class="title mb-5">
        <div class="contact" id="title-bloc"><h4 >Avis récent ({{reviewCompany?.nb_avis}}) </h4></div>
      
    </div>

    <div class="card-body">
       
            <div class="row g-6 g-xl-9 cards">
                <!--begin::Col-->
                <div class="col-sm-6 col-xl-3 col-12" *ngFor="let review of reviewCandidat">
                    <div class="card h-100">
                        <div class=" border-0 pt-5">
                            <div class="card-title">
                              
                                <div class="head-avis mb-5">
                                    <div class="avatar">
                                        <img class="table-img" *ngIf="!review?.image_url"
                                            src="/assets/media/logos/logo-avatar.jpg" width="50px">
                                        <img class="table-img" *ngIf="review?.image_url"
                                            src="{{url +'/User/file/gallery_users/' + review?.image_url}}"
                                            width="50px" />

                                    </div>
                                    <div class="modify text-center"><span>Modifié le
                                            :{{review?.Date_last_update | date:'dd/MM/yyyy'}}</span>
                                    </div>
                                </div>
                                <div class="name-donneur text-center mb-5">
                                    <a class="name cursor-pointer" (click)="navigatToDetailsCandidat(review?.id)">  {{review?.first_name}} {{review?.last_name}}
                                       
                                    </a>
                                </div>
                                <div class="infos text-center">
                                    <span data-bs-toggle="modal" data-bs-target="#modal">Avis Total
                                        : </span>
                                    <div class="text-center" style="margin: auto;">
                                        <div class="stars mb-3">
                                            <rating [titles]="[' ',' ',' ',' ',' ']"
                                                [readonly]="true"
                                                [(ngModel)]="review.avg_rating"
                                                class="rating-stars"></rating>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-6 pb-6">
                            <div class="footer d-flex fw-semibold justify-content-center">
                                <div class="details">

                                    <a class="cursor-pointer"
                                    (click)="openModalDetails(detailsReview,review?.id)">Voir
                                    détail </a>

                                </div>
                            </div>
                        </div>
                      
                    </div>
                </div>
                

                        <div class="alert alert-warning text-center mt-5" role="alert"  *ngIf="!reviewCandidat?.length">
                            <img src="/assets/media/logos/logo-no-data.png" alt="" class="mb-5">
                            <span class="empty-list">
                             La liste est vide
                         </span>
                         </div>
                <!--end::Col-->
            </div>
      
    </div>
</div>
<ng-template #detailsReview>
    <div class="modal-dialog-centered" id="detail-review" tabindex="-1" aria-hidden="true">
        <!--begin::Modal dialog-->
        <!--begin::Modal content-->
        <div class="modal-content">
            <!--begin::Modal header-->
            <div class="modal-header">
                <!--begin::Modal title-->
                <h2 class="">Détails donneur Avis</h2>
                <div id="kt_customers_export_close" data-bs-dismiss="modal"
                    class="btn btn-icon btn-sm btn-active-icon-primary">
                    <i class="ki-duotone ki-cross fs-1" (click)="closeModalDetails()">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </div>
            </div>
            <div class="modal-body">
                <div class="header mb-3 mt-3">
                    <div class="icon text-center mb-10">
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M28.5 0H4.5C3.30693 0.00131022 2.1631 0.475837 1.31947 1.31947C0.475837 2.1631 0.00131022 3.30693 0 4.5V22.5C0.00142898 23.5077 0.340375 24.4859 0.962743 25.2784C1.58511 26.071 2.45503 26.6322 3.43365 26.8725L6.10695 33.5574C6.21818 33.836 6.41036 34.0748 6.65868 34.243C6.907 34.4112 7.20006 34.5012 7.5 34.5012C7.79994 34.5012 8.093 34.4112 8.34132 34.243C8.58964 34.0748 8.78182 33.836 8.89305 33.5574L11.5158 27H28.5C29.6931 26.9987 30.8369 26.5242 31.6805 25.6805C32.5242 24.8369 32.9987 23.6931 33 22.5V4.5C32.9987 3.30693 32.5242 2.1631 31.6805 1.31947C30.8369 0.475837 29.6931 0.00131022 28.5 0ZM26.5605 19.0605L23.5605 22.0605C23.2776 22.3337 22.8987 22.4849 22.5054 22.4815C22.1121 22.4781 21.7359 22.3203 21.4578 22.0422C21.1797 21.7641 21.0219 21.3879 21.0185 20.9946C21.0151 20.6013 21.1663 20.2224 21.4395 19.9395L21.8789 19.5H7.5C7.10218 19.5 6.72064 19.342 6.43934 19.0607C6.15804 18.7794 6 18.3978 6 18C6 17.6022 6.15804 17.2206 6.43934 16.9393C6.72064 16.658 7.10218 16.5 7.5 16.5H21.8789L21.4395 16.0605C21.1663 15.7776 21.0151 15.3987 21.0185 15.0054C21.0219 14.6121 21.1797 14.2359 21.4578 13.9578C21.7359 13.6797 22.1121 13.5219 22.5054 13.5185C22.8987 13.5151 23.2776 13.6663 23.5605 13.9395L26.5605 16.9395C26.6998 17.0787 26.8104 17.244 26.8858 17.426C26.9612 17.608 27.0001 17.803 27.0001 18C27.0001 18.197 26.9612 18.392 26.8858 18.574C26.8104 18.756 26.6998 18.9213 26.5605 19.0605ZM25.5 10.5H11.1212L11.5605 10.9395C11.7038 11.0779 11.818 11.2434 11.8967 11.4264C11.9753 11.6094 12.0166 11.8062 12.0184 12.0054C12.0201 12.2046 11.9822 12.4021 11.9067 12.5864C11.8313 12.7708 11.7199 12.9383 11.5791 13.0791C11.4383 13.2199 11.2708 13.3313 11.0864 13.4067C10.9021 13.4822 10.7046 13.5201 10.5054 13.5184C10.3062 13.5166 10.1094 13.4753 9.92639 13.3967C9.74339 13.318 9.57787 13.2038 9.4395 13.0605L6.4395 10.0605C6.30015 9.92128 6.18961 9.75596 6.11419 9.57399C6.03877 9.39202 5.99995 9.19698 5.99995 9C5.99995 8.80302 6.03877 8.60798 6.11419 8.42601C6.18961 8.24404 6.30015 8.07872 6.4395 7.9395L9.4395 4.9395C9.7224 4.66626 10.1013 4.51507 10.4946 4.51849C10.8879 4.52191 11.2641 4.67966 11.5422 4.95777C11.8203 5.23588 11.9781 5.6121 11.9815 6.0054C11.9849 6.39869 11.8337 6.7776 11.5605 7.0605L11.1212 7.5H25.5C25.8978 7.5 26.2794 7.65804 26.5607 7.93934C26.842 8.22064 27 8.60218 27 9C27 9.39782 26.842 9.77936 26.5607 10.0607C26.2794 10.342 25.8978 10.5 25.5 10.5Z"
                                fill="#265D91" />
                            <path
                                d="M43.5 13.5H36V21C36 20.6022 36.158 20.2207 36.4393 19.9394C36.7206 19.6581 37.1022 19.5 37.5 19.5H40.5C40.8978 19.5 41.2794 19.6581 41.5607 19.9394C41.842 20.2207 42 20.6022 42 21C42 21.3979 41.842 21.7794 41.5607 22.0607C41.2794 22.342 40.8978 22.5 40.5 22.5H37.5C37.1022 22.5 36.7206 22.342 36.4393 22.0607C36.158 21.7794 36 21.3979 36 21V22.5C35.9989 23.5332 35.783 24.5548 35.3659 25.5H40.5C40.8978 25.5 41.2794 25.6581 41.5607 25.9394C41.842 26.2207 42 26.6022 42 27C42 27.3979 41.842 27.7794 41.5607 28.0607C41.2794 28.342 40.8978 28.5 40.5 28.5H34.5C34.1143 28.499 33.744 28.3485 33.4669 28.08C32.1049 29.3109 30.3358 29.9948 28.5 30H15V36C15.0035 37.1924 15.4787 38.335 16.3219 39.1782C17.165 40.0213 18.3076 40.4965 19.5 40.5H36.48L39.105 47.055C39.2164 47.334 39.4088 47.5731 39.6575 47.7416C39.9062 47.9101 40.1996 48.0001 40.5 48.0001C40.8004 48.0001 41.0938 47.9101 41.3425 47.7416C41.5912 47.5731 41.7836 47.334 41.895 47.055L44.565 40.38C45.543 40.1357 46.4117 39.5725 47.0338 38.7792C47.6559 37.986 47.9959 37.0081 48 36V18C47.9965 16.8076 47.5213 15.6651 46.6781 14.8219C45.835 13.9787 44.6924 13.5035 43.5 13.5ZM40.5 34.5H22.5C22.1022 34.5 21.7206 34.342 21.4393 34.0607C21.158 33.7794 21 33.3979 21 33C21 32.6022 21.158 32.2207 21.4393 31.9394C21.7206 31.6581 22.1022 31.5 22.5 31.5H40.5C40.8978 31.5 41.2794 31.6581 41.5607 31.9394C41.842 32.2207 42 32.6022 42 33C42 33.3979 41.842 33.7794 41.5607 34.0607C41.2794 34.342 40.8978 34.5 40.5 34.5Z"
                                fill="#265D91" />
                        </svg>
                    </div>


                </div>
                <div *ngIf="!listCandidatReviewDetails?.stars">Pas de question</div>
                <div class="reply" *ngFor="let review of listCandidatReviewDetails?.stars">
                    <div class="choices">
                        <div class="questions items-stars">
                            <label class="question" for="flexCheckDefault">
                               <ul>
                                <li>
                                    <div [innerHTML]="review?.specific_review?.question"></div>
                                </li>
                               </ul>
                            </label>
                            <div class="d-flex" *ngIf="review?.stars">
                                <div class="stars">
                                    <div style="margin: auto;">
                                        <div class="stars mb-3" *ngIf="review?.stars">
                                            <rating [titles]="[' ',' ',' ',' ',' ']" [(ngModel)]="review.stars"
                                                [readonly]="true" class="rating-stars"></rating>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    <div class="reply-input mb-10" *ngIf="listCandidatReviewDetails?.comment?.comment">
                        <div class="content-comment">
                            <span>{{listCandidatReviewDetails.comment.comment}}</span>
                        </div>
                    </div>
            </div>

            <!--end::Modal body-->
        </div>
        <!--end::Modal content-->
        <!--end::Modal dialog-->
    </div>
</ng-template>